<template>
  <div>
    <div class="form-group">
      <label for="search">{{ $t('search') }}</label>
      <input class="form-control" v-model="input" @change="search" />
    </div>
  </div>
</template>

<script>
export default  {
  name: 'Search',
  data: () => ({
    input: ''
  }),
  created() {
    if(this.$route.query.search){
      this.input = this.$route.query.search;
    }
  },
  methods: {
    search: function(e){
      let query = {
        'search': this.input
      };
      this.$router.push({name: this.$route.name, params: {property: this.$route.params.property, room: this.$route.params.room}, query: query })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "search": "Search"
  },
  "sl": {
    "search": "Išči"
  }
}
</i18n>
